import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResidualsService } from 'app/layout/residuals/residuals.service';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SalesEntityModel } from 'app/shared/models/EvoSalesPortalModel';
import { MerchantService } from 'app/shared/services';
import { MerchantNote } from 'app/shared/models/Notes';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'note-modal',
	styleUrls: ['./notemodal.component.scss'],
	templateUrl: 'notemodal.component.html',
})
export class NoteModalComponent {
	bindingContext: BindingContext = new BindingContext();
	public NoteID: number;
	public note: MerchantNote;
	private noteDetailsArray;

	constructor(public activeModal: NgbActiveModal,
		private toastSvc: ToastrService,
		private mSvc: MerchantService) {
		this.bindingContext.isBusy = false;
	}

	ngOnInit() {
		this.getNote();
	}


	// Called from the constructor for the first load
	getNote() {
		this.bindingContext.beginGet();
		const promise = this.mSvc.getMerchantNote(this.NoteID).toPromise().then(resp => {
			this.note = resp;
			this.bindingContext.endGet();
			this.noteDetailsArray = JSON.parse(this.note.NoteDetails);
		}).catch(err => {
			// problem getting entities
			console.log(err);
			this.bindingContext.endGet();
			this.toastSvc.error('Unable to retrieve note.', 'Server Error');
		});
	}
}
